import Loader from './Loader';

const LoadingPage = () => {
  return (
    <div
      className="h-screen"
      style={{ height: `calc(100vh - var(--header-height) - 32px)` }}
    >
      <Loader />
    </div>
  );
};

export default LoadingPage;
